export default function () {
    if (!String.prototype.includes) {
        String.prototype.includes = function (search, start) {
            if (typeof start !== 'number') {
                start = 0;
            }

            if (start + search.length > this.length) {
                return false;
            } else {
                return this.indexOf(search, start) !== -1;
            }
        };
    }
    
    if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
            value: function(search, pos) {
                return this.substring(!pos || pos < 0 ? 0 : +pos, search.length) === search;
            }
        });
    }


    if (!String.prototype.removeIf) {
        Array.prototype.removeIf = function(callback) {
            var i = 0;
            while (i < this.length) {
                if (callback(this[i], i)) {
                    this.splice(i, 1);
                }
                else {
                    ++i;
                }
            }
        };
    }
}


// WEBPACK FOOTER //
// ./src/polyfill/index.js